/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   ion-title[_ngcontent-%COMP%]{line-height:22px;padding-top:28px}ion-toolbar[_ngcontent-%COMP%]{--min-height:80px}.sub-title[_ngcontent-%COMP%]{line-height:14px;padding-left:5vh}"];
export { styles as styles };
